/* this file is transformed by vux-loader */
/* eslint-disable */
// 工单状态映射表
export var orderStatusMapping = {
  0: '待受理',
  1: '待指派',
  2: '待接单',
  3: '待服务',
  4: '服务中',
  5: '已完成',
  6: '已取消'
}; // 工单状态列表

export var orderStatusList = [// { value: '', name: '全部' },
{
  value: 0,
  name: '待受理'
}, {
  value: 1,
  name: '待指派'
}, {
  value: 2,
  name: '待接单'
}, {
  value: 3,
  name: '待服务'
}, {
  value: 4,
  name: '服务中'
}, {
  value: 5,
  name: '已完成'
}, {
  value: 6,
  name: '已取消'
}]; // 工单相关度列表

export var relevanceList = [{
  value: 1,
  name: '全部工单'
}, {
  value: 2,
  name: '我负责的'
}, {
  value: 3,
  name: '我协同的'
}, {
  value: 4,
  name: '我创建的'
}, {
  value: 5,
  name: '抄送给我'
}, {
  value: 6,
  name: '内部工单'
}]; // 工单列表排序

export var orderSortList = [{
  value: '1',
  name: '创建时间由近到远'
}, {
  value: '4',
  name: '创建时间由远到近'
}, {
  value: '3',
  name: '预约时间由近到远'
}, {
  value: '6',
  name: '预约时间由远到近'
}, {
  value: '2',
  name: '完成时间由近到远'
}, {
  value: '5',
  name: '完成时间由远到近'
}]; // 工单回执状态

export var receiptStateList = [{
  value: '0',
  name: '未回执'
}, {
  value: '1',
  name: '已回执'
}]; // 工单收款状态

export var settlementStateList = [{
  value: '0',
  name: '未收款'
}, {
  value: '1',
  name: '已收款'
}]; // 工单回执状态

export var evaluateStateList = [{
  value: '0',
  name: '未评价'
}, {
  value: '1',
  name: '已评价'
}]; // 工单归档状态

export var orderArchiveType = [{
  value: '0',
  name: '未归档'
}, {
  value: '1',
  name: '已归档'
}]; // 工单来源

export var orderSourceList = [{
  value: '1',
  name: '单小二'
}, {
  value: '2',
  name: '移动网站'
}, {
  value: '3',
  name: '微信公众号'
}, {
  value: '4',
  name: '钉钉浏览器'
}]; // 工单超时状态

export var timeoutStateList = [{
  value: '1',
  name: '是'
}, {
  value: '0',
  name: '否'
}]; // 工单异常

export var abnormalStateList = [{
  value: '1',
  name: '是'
}, {
  value: '0',
  name: '否'
}]; // 工单优先级列表

export var priorityList = [{
  value: '1',
  name: '一般'
}, {
  value: '2',
  name: '紧急'
}, {
  value: '3',
  name: '非常紧急'
}]; // 超时类型

export var orderDueStateList = [{
  name: '受理阶段逾期',
  value: '1'
}, {
  name: '派单阶段逾期',
  value: '2'
}, {
  name: '接单阶段逾期',
  value: '3'
}, {
  name: '预约阶段逾期',
  value: '4'
}, {
  name: '服务阶段逾期',
  value: '5'
}, {
  name: '回执阶段逾期',
  value: '6'
}, {
  name: '收款阶段逾期',
  value: '7'
}, {
  name: '异常处理阶段逾期',
  value: '8'
}, {
  name: '回访阶段逾期',
  value: '9'
}]; // 工单优先级映射表

export var priorityMapping = {
  1: '一般',
  2: '紧急',
  3: '非常紧急'
}; // 工单状态对应色值映射表

export var statusColorMapping = {
  0: '#FFB84D',
  1: '#FFB84D',
  2: '#FFB84D',
  3: '#5ED298',
  4: '#5ED298',
  5: '#6CAFF5',
  6: '#a3a5a7'
};
export var titleRuleSystemFieldList = [{
  key: 'fk_t_ep_service',
  value: '服务项目',
  obj: 'serviceId'
}, {
  key: 'custom_apply_time',
  value: '预约时间',
  obj: 'customApplyTime'
}, {
  key: 'custom_name',
  value: '客户名称',
  obj: 'customName'
}, {
  key: 'link_name',
  value: '联系人',
  obj: 'customLinkPerson'
}, {
  key: 'link_phone',
  value: '联系电话',
  obj: 'customPhone'
}, {
  key: 'custom_enterprise_name',
  value: '企业名称',
  obj: 'customEnterpriseName'
}, {
  key: 'custom_production',
  value: '产品',
  obj: 'productId'
}, {
  key: 'detail_desc',
  value: '详细描述',
  obj: 'detailDesc'
}]; // 服务收款类别

export var payTypeList = [{
  name: '线下支付',
  value: '1'
}, {
  name: '支付宝支付',
  value: '2'
}, {
  name: '微信支付',
  value: '3'
}, {
  name: '银联支付',
  value: '4'
}, {
  name: '签单',
  value: '5'
}];
export var payTypeMapping = {
  1: '线下支付',
  2: '支付宝支付',
  3: '微信支付',
  4: '银联支付',
  5: '签单'
};